import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl28FormDataToModel,
  convertModelToBefehl28FormData
} from './converters'
import { BefehlFormWrapper, BefehlFormProps } from '../Generic'
import { Befehl28 } from '../../../models'
import Auftrag28_10Form from './Auftrag28_10Form'
import Auftrag28_20Form from './Auftrag28_20Form'
import { Befehl28FormData, createBefehl28FormValidationSchema } from './schema'
import { useBefehlForm } from '../../../hooks'

/**
 * Main form component for Befehl 28
 */
export default function Befehl28Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-28-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl28>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl28FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl28FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl28FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl28FormData) => {
      const updatedBefehl = convertBefehl28FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl28FormData>
      befehlKennung="28"
      title={t('befehle.28.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 28.10 */}
      <Auftrag28_10Form
        befehlKennung={'28'}
        fieldPrefix="auftrag_28_10"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-28-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 28.20 */}
      <Auftrag28_20Form
        befehlKennung={'28'}
        fieldPrefix="auftrag_28_20"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-28-20`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
